import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import BackgroundSlider from "react-background-slider";

import slide1 from "../../assect/images/bg/home/dl_homepagecaroussel60-01.jpg";
import slide2 from "../../assect/images/bg/home/dl_homepagecaroussel60-02.jpg";
import slide3 from "../../assect/images/bg/home/dl_homepagecaroussel60-03.jpg";
import slide4 from "../../assect/images/bg/home/dl_homepagecaroussel60-04.jpg";
import slide5 from "../../assect/images/bg/home/dl_homepagecaroussel60-05.jpg";

import stackedLogo from "../../assect/images/dl_logo_stacked_color.svg";
import viewPropertiesButton from "../../assect/images/buttons/ViewProperties.png";

import Navbar from "../../components/navbar";
import dlFFB from "../../assect/images/svg/dl_fb-orange.svg";
import dlIG from "../../assect/images/svg/dl_insta-orange.svg";
import Footer from "../../components/footer";
import AvailableProperties from "../../components/availableproperties";

const images = [slide1, slide2, slide3, slide4, slide5];

export default function Index() {
  return (
    <>
      <Navbar
        navClass="defaultscroll sticky"
        menuClass="navigation-menu nav-right"
      />

      <section className="position-relative mt-5 pt-4">
        <div className="container-fluid px-md-4 px-2 mt-2">
          <BackgroundSlider images={images} duration={5} transition={2} />
          <div
            className="bg-home-one bg-half-170 d-table w-100 overflow-hidden"
            id="home"
          >
            <div className="container">
              <div className="row justify-content-center">
                <div
                  className="col-xl-6 col-lg-8 col-12"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "45vh",
                  }}
                >
                  <div style={{ marginRight: "auto", marginLeft: "auto" }}>
                    <ul
                      style={{
                        listStyleType: "none",
                        marginLeft: "auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <li style={{ padding: "28px" }}>
                        <img
                          src={stackedLogo}
                          alt="Dimora Living"
                          className="banner_txt"
                        />
                      </li>
                      <li style={{ padding: "20px" }}>
                        <p
                          className="letterspacing-2 banner_sub_txt"
                        >
                          STYLISH FURNISHED AND UNFURNISHED APARTMENTS IN NEW
                          YORK'S CAPITAL REGION
                        </p>
                      </li>
                      <li style={{ padding: "20px" }}>
                        <Link
                          reloadDocument
                          to={{
                            pathname: "/PropertyListing",
                            search: "propertyType=F",
                            key: uuidv4(),
                          }}
                          className="text-foot"
                        >
                          <img
                            src={viewPropertiesButton}
                            width="166"
                            height="76"
                            alt="View Properties"
                            className="scale_hover"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer style={{ backgroundColor: "transparent" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div>
                <div className="row">
                  <div
                    className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "end",
                    }}
                  >
                    <ul className="list-unstyled footer-list section-mb-xx">
                      {/* <a href="javascript:void(0);" target="_blank">
                        <img src={dlFFB} width="40" alt="Facebook" />
                      </a> */}
                      {/* <button type="button" onClick={() => console.log('Facebook link coming soon')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>     
                        <img src={dlFFB} width="40" alt="Facebook" style={{ paddingRight: "5px"}}/>
                      </button> */}
                      <a
                        href="https://www.facebook.com/people/Dimora-Living/61572466509114/?sk=about"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={dlFFB} width="40" alt="Facebook" style={{ paddingRight: "5px" }} />
                      </a>
                      &nbsp;
                      <a
                        href="https://www.instagram.com/dimora_living/"
                        target="_blank"
                      >
                        <img src={dlIG} width="40" alt="Instagram" />
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <section
        className="position-relative avaliable_sec"
        style={{ backgroundColor: "#faf4e6" }}
      >
        <div className="container mb-60 mt-60">
          <div className="row">
            <div className="col-12">
              <AvailableProperties />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
